module.exports = __webpack_public_path__ + "img/2.ee519c60.jpg";